import { render } from "./mainswiper.vue?vue&type=template&id=6e043c9d&scoped=true"
import script from "./mainswiper.vue?vue&type=script&lang=js"
export * from "./mainswiper.vue?vue&type=script&lang=js"

import "./mainswiper.vue?vue&type=style&index=0&id=6e043c9d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e043c9d"],['__file',"src/js/components/mainswiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e043c9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e043c9d', __exports__)) {
    api.reload('6e043c9d', __exports__)
  }
  
  module.hot.accept("./mainswiper.vue?vue&type=template&id=6e043c9d&scoped=true", () => {
    api.rerender('6e043c9d', render)
  })

}


export default __exports__